import { useMutation } from '@tanstack/react-query';
import { useRef } from 'react';
export const createUseBosMutation = ({ onUnhandledError }) => (options) => {
    const errorHandledInRoot = useRef(false);
    const { mutate, mutateAsync, ...useMutationRest } = useMutation({
        ...options,
        onError: (error, variables) => {
            if (!options.onError)
                return;
            const { errorHandled } = options.onError(error, variables);
            if (errorHandled) {
                errorHandledInRoot.current = true;
            }
        },
    });
    const bosMutate = (variables, mutateOptions) => {
        mutate(variables, {
            ...mutateOptions,
            onError: (error, errorVariables) => {
                const unhandledErrorMessage = mutateOptions?.unhandledErrorMessage ??
                    options.unhandledErrorMessage;
                if (!mutateOptions?.onError) {
                    if (!errorHandledInRoot)
                        onUnhandledError(error, unhandledErrorMessage);
                }
                else {
                    const { errorHandled } = mutateOptions.onError(error, errorVariables);
                    if (!errorHandled && !errorHandledInRoot)
                        onUnhandledError(error, unhandledErrorMessage);
                }
                errorHandledInRoot.current = false;
            },
        });
    };
    return { ...useMutationRest, mutate: bosMutate };
};
